import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/employee-management-system/leave-management/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "leave-management" entry is kept); the seo block below is a fallback.

export const leaveManagement: ContentPage = {
  slug: "employee-management-system/leave-management",
  template: "hrmsFeature",
  seo: {
    title: "Efficient Leave Management System for Seamless Approvals",
    description: "Handle employee leave requests with automated workflows, custom policies, and real-time leave balance tracking for smooth operations.",
    keywords: [
      "leave management system",
      "employee leave software",
      "automated leave approval",
      "vacation tracking software",
      "sick leave management",
      "HR leave system.",
    ],
    ogImage: "/assets/data/seoimages/leave-management.webp",
  },
  leaf: {
    hero: {
      caption: "Leave Management",
      title: "Efficient Leave Management for a Balanced Workforce",
      description: "Simplify leave requests and approvals with automated workflows, ensuring smooth operations and minimal disruptions.",
      h1: "caption",
    },
    split: {
      title: "Manage Leave Requests with Ease",
      bullets: [
        { title: "Custom Leave Policies", description: "Establish tailored leave rules for your team." },
        { title: "Automated Approval Workflow", description: "Simplify the leave approval process." },
        { title: "Leave Balance Tracking", description: "Keep track of employee leave balances." },
        { title: "Leave History Transparency", description: "Provide clear records of past leaves." },
      ],
      image: "/assets/images/img/product/hrms/employeems/leave_management_image.webp",
      imageAlt: "leave-management",
    },
    cardsHeading: {
      title: "Key Features of Employee Management System",
      description: "Optimize Employee management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Attendance Tracking",
        href: "/hrms-software/employee-management-system/attendance-tracking",
        description: "Track and monitor employee attendance with real-time clock-in/out, ensuring precise records for improved productivity and payroll accuracy.",
        image: "/assets/images/img/product/hrms/employeems/attendance_tracking_images.webp",
        imageAlt: "attendance_tracking_key_features",
      },
      {
        title: "Employee Directory",
        href: "/hrms-software/employee-management-system/employee-directory",
        description: "Easily manage employee profiles, personal details, roles, and contact information in a secure and centralized directory for streamlined operations.",
        image: "/assets/images/img/product/hrms/employeems/employee_directory_image.webp",
        imageAlt: "employee_directory_key_features",
      },
      {
        title: "Performance Review",
        href: "/hrms-software/employee-management-system/performance-review",
        description: "Track employee performance, set KPIs, and provide feedback with structured review processes for better productivity and growth.",
        image: "/assets/images/img/product/hrms/employeems/performance_review.webp",
        imageAlt: "performance_review",
      },
      {
        title: "Shift Management",
        href: "/hrms-software/employee-management-system/employee-shift-management",
        description: "Automate and organize shift scheduling, manage shift swaps, and ensure proper staffing with a powerful shift management system.",
        image: "/assets/images/img/product/hrms/employeems/shift_management.webp",
        imageAlt: "shift_management",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Streamline Leave Management for Your Workforce!",
    relatedBlogs: "static",
    metaKey: "leave-management",
  },
  sections: [],
};
